export default __webpack_public_path__ + "static/media/Prophecy_3x2_En.03bb1c1c.webp";